import { Heading, TabBar } from '@tmov/design-system';
import React, { useState } from 'react';

import Geral from './Geral';
import { Container, Header, HeaderLeft } from './styles';
import Transportadoras from './Transportadoras';

const tabs = [
  { id: 1, title: 'Geral', content: <Geral /> },
  { id: 2, title: 'Transportadoras', content: <Transportadoras /> },
];

function Dashboards() {
  const [selectedTabId, setSelectedTabId] = useState(1);

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <Heading variant="h2">Dashboard</Heading>
        </HeaderLeft>
      </Header>
      <TabBar
        selectedTabId={selectedTabId}
        onChange={tabId => setSelectedTabId(tabId)}
        tabs={tabs}
      />
    </Container>
  );
}

export default Dashboards;
